"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importStar(require("axios"));
const PodioErrorFactory_1 = __importDefault(require("../utils/PodioErrorFactory"));
/**
 * Common class for handling all the Http client requests
 */
class HttpClient {
    /**
     * Assign values to the private variable
     * @constructor
     * @param requestObj
     */
    constructor(requestData) {
        /**
         * Podio API base url
         *
         * @type {string}
         */
        this.base_url = 'https://api.podio.com';
        this.request = requestData;
    }
    /**
     * Http call
     *
     * @returns Promise<HttpResponse>
     */
    call() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let response = yield (0, axios_1.default)(Object.assign(Object.assign({}, this.request), { baseURL: this.base_url }));
                let responseData = {
                    status: response.status,
                    statusText: response.statusText,
                    headers: response.headers,
                    request: response.request,
                    data: response.data,
                    response: response,
                };
                return responseData;
            }
            catch (e) {
                if (e instanceof axios_1.AxiosError) {
                    let statusCode = (_b = (_a = e.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 0;
                    let errorMessage = (_e = (_d = (_c = e.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.error_description) !== null && _e !== void 0 ? _e : e.message;
                    let podioErrorData = (_h = (_g = (_f = e.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.request) !== null && _h !== void 0 ? _h : undefined;
                    let errorClass = PodioErrorFactory_1.default.getError(statusCode);
                    throw new errorClass(errorMessage, podioErrorData, statusCode);
                }
                throw e;
            }
        });
    }
}
exports.default = HttpClient;
